/**
 * Formats row data for use in the DataTable component.
 * This function maps each item in the data array to an array of values
 * based on the column definitions. It uses the formatters defined in the
 * columns array to format the data as needed.
 *
 * @param {Array} data - The array of data objects to be formatted.
 * @param {Array} columns - The array of column definitions.
 * @returns {Array} - An array of arrays, where each inner array represents a row of formatted data.
 */
export default function formatRow(data = [], columns) {
  	// Ensure that data is an array
  const normalizedData = Array.isArray(data) ? data : [];
  
  return normalizedData.map((item, index) =>
    columns?.map(
      (col) => {
        // If column has formatters, use them with rowData
        if (col?.cell?.formatters?.[0]) {
          const result = col.cell.formatters[0](col.property ? item[col.property] : undefined, { rowData: item, index });
          // If formatter returns something (including null/undefined for empty cells), use it
          // Otherwise fall back to property value if it exists
          return result !== undefined ? result : (col.property ? item[col.property] : null);
        }
        // If no formatter, just return the property value
        return col.property ? item[col.property] : null;
      }
    )
  );
}

export const formatRow2 = (data, columns) => {
  return data?.map((item) =>
    columns?.map((col) => {
      const value = item[col.property];
      if (typeof value === 'string') {
        return value;
      }

      if (Array.isArray(value)) {
        return value.join(', ');
      }

      if (value && (value.$$typeof || value instanceof HTMLElement)) {
        return value;
      }

      if (value && typeof value === 'object') {
        return value.name || value.units || (value.quantity ? String(value.quantity) : JSON.stringify(value));
      }

      return col.cell?.formatters[0](value, { rowData: item }) || value;
    })
  );
};


